<template>
  <div class="home-page">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 轮播图部分 -->
      <section class="banner-section">
        <el-carousel height="538px" :interval="3500" arrow="always">
          <el-carousel-item v-for="(slide, index) in heroSlides" :key="index">
            <div class="banner-slide" :style="{ backgroundImage: `url(${slide.image})` }">
              <div class="banner-overlay">
                <h1 class="banner-title">{{ $t('home.slogan') }}</h1>
                <p class="banner-subtitle">{{ slide.description }}</p>

              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>



      <!-- 公司介绍（正式文案与优化排版） -->
      <section class="about-section">
        <div class="container">
          <h2 class="section-title accent">{{ $t('home.companyIntro.title') }}</h2>
          <div class="about-card">
            <div class="about-content">
              <p>{{ $t('home.companyIntro.p1') }}</p>
              <p>{{ $t('home.companyIntro.p2') }}</p>
              <p>{{ $t('home.companyIntro.p3') }}</p>
            </div>

          </div>
        </div>
      </section>
   
    <!-- 之于行团队概况 -->
    <section class="team-overview-section">
      <div class="container">
        <div class="team-overview-content">
          <!-- 左侧：背景信息 -->
          <div class="team-background">
            <div class="background-header">
              <div class="header-icon" style="background: white;">
                <img src="@/assets/images/homepageimg/gaikuangicon1.png" alt="背景"  >
              </div>
              <h3 class="background-title">{{ $t('home.background.title') }}</h3>
            </div>
            <div class="background-content">
              <p class="background-text">
                {{ $t('home.background.prefix') }}<span class="highlight-text">{{ $t('home.background.cas') }}</span>{{ $t('home.background.suffix') }}
              </p>
              <p class="background-subtitle">
                <span class="national-badge">{{ $t('home.background.nationalBadge') }}</span>
              </p>
            </div>
            
            <div class="organization-info" style="margin-top: 3.3rem">
              <div class="org-header">
                <div class="header-icon" style="background: white;">
                 <img src="@/assets/images/homepageimg/gaikuangicon1.png" alt="背景"  >
                </div>
                <h3 class="org-title">{{ $t('home.agency.title') }}</h3>
              </div>
              <div class="org-content">
                <p class="org-code">{{ $t('home.agency.label') }}11767</p>
              </div>
            </div>
          </div>
          
          <!-- 右侧：数据统计 -->
          <div class="team-statistics">
            <div class="stats-header">
              <div class="header-icon" style="width: 34px;height:34px;background: white;">
              <img src="@/assets/images/homepageimg/gaikuangicon2.png" alt="背景"  >
              </div>
              <h3 class="stats-title">{{ $t('home.stats.title') }}</h3>
            </div>
            
            <!-- 人员图标展示 -->
            <div class="team-icons" style="background: white;border: 2px solid rgba(255, 99, 30, 0.1);">
              <div class="team-icon" v-for="n in 9" :key="n" style="background: white;">
                <img src="@/assets/images/homepageimg/gaikuangicon3.png" alt="背景"  style="width:3.5rem;">
              </div>
            </div>
            
            <!-- 统计数据 -->
            <div class="stats-grid">
              <div class="stat-item senior-engineers">
                <div class="stat-label">{{ $t('home.stats.line1_prefix') }}<span class="highlight-text">{{ $t('home.stats.line0_suffix') }}</span>{{ $t('home.stats.line1_suffix') }}<span class="highlight-text">20%</span></div>
                <div class="stat-label">{{ $t('home.stats.line2_prefix') }}<span class="highlight-text">985/211</span>{{ $t('home.stats.line2_suffix') }} <span class="highlight-text">100%</span></div>
                <div style="display: flex;flex-direction: row;width: 100%;"> <div class="stat-label">{{ $t('home.stats.line3_prefix') }} <span class="highlight-text">{{ $t('home.stats.line31_prefix') }}</span><span>{{ $t('home.stats.line32_prefix') }}</span></div>
               </div>
              </div>
              
             
              
             
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- 新增模块--行业荣誉与专业资质-->
    <section class="honors-credentials-section">
      <div class="container">
        <div class="section-header">
          <h2 class="honors-title">{{ $t('home.honors.title') }}</h2>
          <p class="honors-description">
            {{ $t('home.honors.desc') }}
          </p>
        </div>

        <!-- 第三排：三张图片平分（独立样式类，避免受其他样式影响） -->
        <div class="honors-grid-top">
          <div class="honor-card-top">
            <img src="@/assets/images/homepageimg/pinshu01.png" alt="行业荣誉与专业资质图1" class="honor-image-top">
          </div>
          <div class="honor-card-top">
            <img src="@/assets/images/homepageimg/pinshu02.png" alt="行业荣誉与专业资质图2" class="honor-image-top">
          </div>
          <div class="honor-card-top">
            <img src="@/assets/images/homepageimg/pinshu03.png" alt="行业荣誉与专业资质图3" class="honor-image-top">
          </div>
        </div>

        <!-- 第四排：三张图片平分 -->
        <div class="honors-grid">
          <div class="honor-item">
            <img src="@/assets/images/homepageimg/pinshu04.png" alt="行业荣誉与专业资质图4" class="honor-image">
          </div>
          <div class="honor-item">
            <img src="@/assets/images/homepageimg/pinshu05.png" alt="行业荣誉与专业资质图5" class="honor-image">
          </div>
          <div class="honor-item">
            <img src="@/assets/images/homepageimg/pinshu06.png" alt="行业荣誉与专业资质图6" class="honor-image">
          </div>
        </div>
      </div>
    </section>

      <!-- 行业协会的认可与感谢 -->
      <section class="high-value-patent-section">
        <div class="container">
          <div class="section-header">
            <h2 class="patent-title">{{ $t('home.assoc.title') }}</h2>
          </div>

          <div class="patent-images-grid">
            <div class="patent-image-item">
              <img src="@/assets/images/homepageimg/anli01.png" alt="高价值专利评估案例1" class="patent-image">

            </div>
            <div class="patent-image-item no-caption">
              <img src="@/assets/images/homepageimg/anli02.png" alt="高价值专利评估案例2" class="patent-image">
            </div>
            <div class="patent-image-item no-caption">
              <img src="@/assets/images/homepageimg/anli03.png" alt="高价值专利评估案例3" class="patent-image">
            </div>
          </div>
          <div style="display: flex;flex-direction: row;width:100%">
            <div class="shared-caption-container"  style="  margin-left: 5%;">
              <div class="shared-caption">
                <p class="caption-text">{{ $t('home.assoc.caption1') }}</p>
              </div>
            </div>
            <!-- 第二和第三张图片共享的说明文字 -->
            <div class="shared-caption-container" style=" margin-left: calc(44% - 10%)">
              <div class="shared-caption">
                <p class="caption-text">{{ $t('home.assoc.caption2') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 服务期超过五年的高满意度客户 -->
      <section class="high-satisfaction-clients-section">
        <div class="container">
          <div class="section-header">
            <h2 class="clients-title">{{ $t('home.clients.title') }}</h2>
            <p class="clients-description">
              {{ $t('home.clients.desc') }}
            </p>
          </div>
          
          <!-- 客户展示网格 -->
          <div class="clients-grid">
            <div class="client-item" v-for="(client, index) in clientsList" :key="index">
              <div class="client-image">
                <img :src="client.image" :alt="client.name" class="client-logo">
              </div>
              <div class="client-name">{{ $t('home.clients.names.' + index) }}</div>
            </div>
          </div>
        </div>
      </section>
           
    </main>

    <!-- 页脚 -->
    <Footer />

    <!-- 联系我们弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="70%" :show-close="false" top="1vh" custom-class="contact-dialog">
      <div class="dialog-content">
        <div class="dialog-header" v-show="anliNum == 1 || anliNum == 2">
          <h2 class="dialog-title">我们的服务流程</h2>
          <p class="dialog-subtitle">从初步咨询到成功授权，我们全程为您保驾护航。</p>
        </div>
        <div class="dialog-header" v-show="anliNum == 3">
          <h2 class="dialog-title" style="color: red;">小词酿大祸：专利翻译误区案例剖析</h2>
          <p class="dialog-subtitle"> </p>
        </div>
        <div class="dialog-body">
          <div class="image-gallery">
            <div class="gallery-item">
              <img
                :src="(anliNum === 1 && showcaseItems[0].image) || (anliNum === 2 && showcase2Items[0].image) || (anliNum === 3 && showcase33Items[0].image)"
                alt="初步咨询" class="gallery-image">
              <div class="item-caption"> {{ anliNum == 1 || anliNum == 2 ? "初步咨询" : "原文" }}</div>
            </div>
            <div class="gallery-item">
              <img
                :src="(anliNum === 1 && showcaseItems[1].image) || (anliNum === 2 && showcase2Items[1].image) || (anliNum === 3 && showcase33Items[1].image)"
                alt="初步咨询" class="gallery-image">
              <div class="item-caption"> {{ anliNum == 1 || anliNum == 2 ? "方案分析" : "原译文" }} </div>
            </div>
            <div class="gallery-item">
              <img
                :src="(anliNum === 1 && showcaseItems[2].image) || (anliNum === 2 && showcase2Items[2].image) || (anliNum === 3 && showcase33Items[2].image)"
                alt="成功授权" class="gallery-image">
              <div class="item-caption">{{ anliNum == 1 || anliNum == 2 ? "成功授权" : "建议译文" }} </div>
            </div>
          </div>
          <div class="text-content" v-show="anliNum == 1 || anliNum == 2">
            <div style="font-weight:bold;font-size: 18px;color:balck">客户初始交底</div>
            <p v-show="anliNum == 1">
              客户提供的技术交底材料完整度较高，专利申请文本框架完整且技术细节详实，技术效果描述与方案对应性良好。所附手绘制图部件标识清晰、结构表达准确，但存在装配关系合理性存疑及是否符合《专利法》第22条第3款创造性要求的风险。
            </p>
            <p v-show="anliNum == 2">
              客户初始交底的技术问题明确、技术方案描述清晰且技术效果表达准确，同时，附图表达了较为完善的技术信息，但不具备将产品顺利运作的结构细节，也就是本领域技术人员无法通过该交底所记载的内容完成技术方案的内容。
            </p>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:85px">我方优化过程</div>
            <p v-show="anliNum == 1">
              我方正式撰写及制作申请文本阶段，与客户积极沟通该案的技术细节及相关临床经验，并多次向医疗器械领域专家咨询意见，整合出"一种导管固定装置及系统"的技术方案，期间研讨了《专利法》等相关法律法规，对该案申请文本以及撰写稿件进行全面优化。
            </p>
            <p v-show="anliNum == 2">
              我方在撰写过程中结合我方的三维建模制图成品，与客户反复讨论，优化了大量机械结构细节，同时考虑了枪头与产品的比例关系，完整绘制了产品运作时的过程场景，增加关键结构的局部放大图或内部结构拆解图，使得技术方案符合《专利审查指南》关于充分公开的规范要求。
            </p>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:83px">专利授权公告文本</div>
            <p v-show="anliNum == 1">
              该高质量专利于2024年01月15日向国家知识产权局提交发明专利申请，2024年02月20被公布，2024年04月09日成功获得授权，授权公告号为CN117563096B。</p>
            <p v-show="anliNum == 2">
              该高质量专利于2024年02月09日向国家知识产权局提交实用新型专利申请，2024年09月17日成功获得授权，授权公告号为CN221714375U。</p>
          </div>
          <div class="text-content" v-show="anliNum == 3">
            <div style="font-weight:bold;font-size: 18px;color:balck">错误分析（一）</div>
            <p>
              •&nbsp;→&nbsp;原译文中，"comprising"被错误地翻译为"由……构成"，形成了封闭性限定，从而误认为技术方案中只包含明确指出的元素，而不包含任何其他元素。这意味着，如果第三方产品或方法中包含了权利要求中提到的所有元素，但还额外添加了任何其他元素，那么它就不算侵犯该专利。这导致保护范围被严重缩窄。
            </p>
            <p>
              •&nbsp;→&nbsp;校对译文中，"comprising"译为"含有"，表示所描述的范围是开放的，可以包含其他未明确指出的元素，只要包含技术方案中提到的所有元素即可。这意味着，即使第三方产品或方法中包含了技术方案中提到的所有元素，并且还额外添加了一些其他元素，只要它满足了技术方案中提到的所有部分，仍然可能被认为是侵犯了该专利。因此，保护范围更为宽泛。
            </p>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:45px">错误分析（二）</div>
            <div>
              •原译文中未将"or"译出，导致技术方案可能被错误地理解为：
              <div>上述的扩散阻挡层优选<span style="color:red">由</span>以下组分<span style="color:red">构成</span>：</div>
              <div> -&nbsp;→&nbsp; AlB2，<span style="color:red">及</span></div>
              <div> -&nbsp;→&nbsp;AlWB2，<span style="color:red">及</span></div>
              <div> -&nbsp;→&nbsp;AlB2和AlWB2，<span style="color:red">及</span></div>
              <div>-&nbsp;→&nbsp;TM硼化物，其中，TM是选自以下组的一个或多个过渡金属：3d、4d和5d元素，该层还含有铝。</div>
            </div>
            <p style="margin-top:0.8rem">
              •&nbsp;→&nbsp;校对译文明确了"或者"的含义，表明这种包含是择一的，而非并行的。</p>

          </div>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">{{$t('closestr')}}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'HomePage',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      dialogVisible: false,
      zhuanlibookimg: require('@/assets/images/homepageimg/德汉教材.png'),
      showcaseImage1: require('@/assets/images/homepageimg/翻译1.png'),
      showcaseImage2: require('@/assets/images/homepageimg/翻译2.png'),
      showcaseImage3: require('@/assets/images/homepageimg/翻译3.png'),
      heroSlides: [
        {
          title: '得之于心，践之于行。',
          description: '',
          image: require('@/assets/images/homepageimg/jianjieimg.png')
        }
      ],
      // 高满意度客户列表
      clientsList: [
        { name: '瑞士欧瑞康集团', image: require('@/assets/images/homepageimg/kehu01.png') },
        { name: '阿特拉斯·科普柯集团', image: require('@/assets/images/homepageimg/kehu02.png') },
        { name: '清华大学', image: require('@/assets/images/homepageimg/kehu03.png') },
        { name: '北京大学', image: require('@/assets/images/homepageimg/kehu04.png') },
        { name: '华中科技大学', image: require('@/assets/images/homepageimg/kehu05.png') },
        { name: '首都医科大学宣武医院', image: require('@/assets/images/homepageimg/kehu06.png') },
        { name: '中国计量科学研究院', image: require('@/assets/images/homepageimg/kehu07.png') },
        { name: '北京住总集团有限责任公司', image: require('@/assets/images/homepageimg/kehu08.png') },
        { name: '泸州老窖股份有限公司', image: require('@/assets/images/homepageimg/kehu09.png') },
        { name: '广东省岭南南丁格尔护理研究院', image: require('@/assets/images/homepageimg/图片1.png') }
      ],
      // 创意天地（假数据，占位图来源：unsplash）
      creativeList: [
        {
          title: 'AI与专利布局的未来',
          desc: '人工智能在专利检索、撰写与诉讼中的应用趋势。',
          image: 'https://images.unsplash.com/photo-1518779578993-ec3579fee39f?q=80&w=1200&auto=format&fit=crop'
        },
        {
          title: '硬核工业设计灵感',
          desc: '从机械美学到人因工程，设计与功能的统一。',
          image: 'https://images.unsplash.com/photo-1472289065668-ce650ac443d2?q=80&w=1200&auto=format&fit=crop'
        },
        {
          title: '绿色材料创新',
          desc: '环保材料推动可持续产品与专利技术突破。',
          image: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?q=80&w=1200&auto=format&fit=crop'
        },
        {
          title: '医疗科技的专利策略',
          desc: '医疗器械与生物医药的专利保护与合规挑战。',
          image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?q=80&w=1200&auto=format&fit=crop'
        }
      ],
      // 专利诉讼案例（假数据）
      patentCases: [
        {
          title: '某电子企业 vs. 某移动终端公司',
          brief: '涉及通信协议核心专利，法院一审支持禁令与赔偿。',
          image: 'https://images.unsplash.com/photo-1555374018-13a8994ab246?q=80&w=1200&auto=format&fit=crop'
        },
        {
          title: '新能源电池封装专利纠纷',
          brief: '聚焦结构改良的等同侵权认定与证据固定。',
          image: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?q=80&w=1200&auto=format&fit=crop'
        }
      ],
      // 无效诉讼案例（假数据）
      invalidCases: [
        {
          title: '图像处理算法专利无效宣告请求',
          brief: '以对比文件组合与功能性特征为突破口成功无效。',
          image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1200&auto=format&fit=crop'
        },
        {
          title: '医用耗材结构专利部分无效',
          brief: '限定权利要求范围，保留核心保护点后维持稳定。',
          image: 'https://images.unsplash.com/photo-1581093588401-16ec6b1644fe?q=80&w=1200&auto=format&fit=crop'
        }
      ],
      // 无效诉讼图片
      invalidImage1: require('@/assets/images/homepageimg/无效专利图1.png'),
      invalidImage2: require('@/assets/images/homepageimg/无效专利图2.png'),
      invalidImage3: require('@/assets/images/homepageimg/无效专利图3.png'),
      // 案例展示数据
      showcaseItems: [
        {
          title: '创意构思与分析',
          desc: '深入了解您的创新思路，通过专业分析确定可专利性和保护策略，为您的创意提供最佳的知识产权保护方案。',
          image: require('@/assets/images/homepageimg/创意1.1.png')
        },
        {
          title: '专业技术制图',
          desc: '运用专业制图软件，精确绘制技术方案图纸，确保专利申请文件的技术描述清晰准确，符合审查要求。',
          image: require('@/assets/images/homepageimg/创意1.2.png')
        },
        {
          title: '专利撰写与申请',
          desc: '资深专利代理师撰写高质量专利申请文件，全程跟踪申请流程，确保您的专利权益得到最大化保护。',
          image: require('@/assets/images/homepageimg/创意1.3.png')
        }
      ],
      // 案例展示数据
      showcase2Items: [
        {
          title: '创意构思与分析',
          desc: '深入了解您的创新思路，通过专业分析确定可专利性和保护策略，为您的创意提供最佳的知识产权保护方案。',
          image: require('@/assets/images/homepageimg/创意2.1.png')
        },
        {
          title: '专业技术制图',
          desc: '运用专业制图软件，精确绘制技术方案图纸，确保专利申请文件的技术描述清晰准确，符合审查要求。',
          image: require('@/assets/images/homepageimg/创意2.2.png')
        },
        {
          title: '专利撰写与申请',
          desc: '资深专利代理师撰写高质量专利申请文件，全程跟踪申请流程，确保您的专利权益得到最大化保护。',
          image: require('@/assets/images/homepageimg/创意2.3.png')
        }
      ],
      anliNum: 1,


      // 案例展示数据
      showcase3Items: [
        {
          title: '原文',
          desc: '',
          image: require('@/assets/images/homepageimg/1h原文.png')
        },
        {
          title: '原译文',
          desc: '',
          image: require('@/assets/images/homepageimg/2h原译文.png')
        },
        {
          title: '建议译文',
          desc: '',
          image: require('@/assets/images/homepageimg/3h建议译文.png')
        }
      ],
      showcase33Items: [
        {
          title: '原文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi1原文.png')
        },
        {
          title: '原译文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi2原译文.png')
        },
        {
          title: '建议译文',
          desc: '',
          image: require('@/assets/images/homepageimg/fanyi3建议译文.png')
        }
      ],
    }
  },
  methods: {
    goToContact(num) {
      this.anliNum = num
      this.dialogVisible = true;
    },

  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  .high-value-patent-section {
    padding: 3rem 0;
  }

  .patent-images-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 400px;
    margin: 0 auto 2.5rem;
  }

  .patent-image {
    height: 200px;
  }

  .patent-title {
    font-size: 1.6rem;
  }

  .patent-footer-text {
    font-size: 1.1rem;
    padding: 0.8rem 1.5rem;
  }

}


/* 高价值专利评估案例区域样式 */
.high-value-patent-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
}

.high-value-patent-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="%23e2e8f0" opacity="0.4"/></pattern></defs><rect width="100" height="100" fill="url(%23dots)"/></svg>');
  pointer-events: none;
}

.high-value-patent-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.patent-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.4;
  position: relative;
  display: inline-block;
}

.patent-title::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
}

/* 三张图片均分布局 */
.patent-images-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 2.5rem;
  position: relative;
  z-index: 1;
  height: 33rem;
}

.patent-image-item {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
}

.patent-image-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.patent-image-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.patent-image-item:hover::before {
  opacity: 1;
}

.patent-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.patent-image-item:hover .patent-image {
  transform: scale(1.05);
}

/* 底部文字 */
.patent-footer {
  text-align: center;
  position: relative;
  z-index: 1;
}

.patent-footer-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  padding: 1rem 2rem;
  background: white;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  display: inline-block;
  border: 2px solid #FF631E;
  position: relative;
  overflow: hidden;
}

.patent-footer-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 99, 30, 0.1), transparent);
  transition: left 0.5s ease;
}

.patent-footer-text:hover::before {
  left: 100%;
}

/* 弹窗样式 */
.contact-dialog .el-dialog__header {
  display: none;
}

.contact-dialog .el-dialog__body {
  padding: 0;
  border-radius: 15px;
}

.dialog-content {
  padding: 2rem 2.5rem;
  background: #f8f9fa;
}

.dialog-header {
  text-align: center;
  margin-bottom: 2rem;
}

.dialog-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.dialog-subtitle {
  font-size: 1rem;
  color: #666;
}

.dialog-body {
  display: flex;
  gap: 2.5rem;
  align-items: flex-start;
}

.dialog-body .image-gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 0 0 320px;
}

.gallery-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  text-align: left;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.gallery-item img {
  width: 18.75rem;
  /* 300px */
  border-radius: 8px;
  flex-shrink: 0;
}

.gallery-image {
  height: 9.375rem;
  /* 150px */
  object-fit: contain;
}

.gallery-item .item-caption {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.dialog-body .text-content {
  flex: 1;
  min-width: 0;
  text-align: justify;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #555;
}

.dialog-body .text-content p {
  margin-bottom: 1rem;
}

.dialog-footer {
  text-align: center;
  margin-top: 0rem;
}

.home-page {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 轮播图样式 */
.banner-section {
  position: relative;
  width: 100%;
  height: 538px;
  overflow: hidden;
}

.banner-slide {
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 0 20px;
}

.banner-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.banner-subtitle {
  font-size: 1.5rem;
  margin: 0 0 30px;
  max-width: 800px;
  line-height: 1.5;
}

/* 自定义轮播图样式 */
.el-carousel__item {
  height: 100%;
}

/* 通用部分样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 4rem 0;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
}

.section-text {
  font-size: 1.1rem;
  line-height: 1.6;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  color: #666;
}

/* 简介部分样式 */
.intro-section {
  background-color: #f8f9fa;
  padding: 4rem 0;
}

.intro-content {
  text-align: center;
}

/* 公司介绍 */
.about-section {
  background: #FFF5F0;
  padding: 0rem 0;
}

.section-title.accent {
  color: #FF631E;
  font-size: 2.5rem;
  padding-bottom: 1.4rem;
}

.about-card {
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2rem 0.5rem 2rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.about-content p {
  font-size: 0.98rem;
  line-height: 1.9;
  color: #333;
  margin-bottom: 1rem;
  text-align: justify;
}

.about-side .metrics {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-bottom: 1.2rem;
}

.metric {
  background: #fff7f3;
  border: 1px solid #ffe3d6;
  border-radius: 10px;
  padding: 0.7rem 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
}

.metric .num {
  font-size: 1.6rem;
  color: #FF631E;
  font-weight: 700;
}

.metric .txt {
  color: #666;
}

.about-cta .el-button--primary {
  background: #FF631E;
  border-color: #FF631E;
}

/* 创意天地 */
.creative-section {
  padding: 2rem 0;
  background-image: url('~@/assets/images/homepageimg/创意天地.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.creative-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.creative-section .container {
  position: relative;
}

.creative-section .section-title,
.creative-section .section-sub {
  color: #fff;
}

.section-head {
  text-align: center;
  margin-bottom: 1.5rem;
}

.section-sub {
  color: #666;
  font-size: 0.95rem;
}

.creative-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.creative-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transition: transform .25s ease, box-shadow .25s ease;
}

.creative-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.1);
}

.creative-card .cover {
  height: 180px;
  background-size: cover;
  background-position: center;
}

.creative-card .body {
  padding: 1rem 1.1rem 1.2rem;
}

.creative-card .title {
  font-size: 1.1rem;
  margin-bottom: .5rem;
  color: #333;
}

.creative-card .desc {
  color: #666;
  font-size: .95rem;
  line-height: 1.6;
}

/* 案例展示部分 */
.showcase-section {
  padding: 0rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.showcase-section .section-head {
  text-align: center;
  margin-bottom: 3rem;
}

.showcase-section .section-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.showcase-section .section-sub {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.showcase-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}

.showcase-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 280px;
}

.showcase-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
}

.showcase-image {
  height: 200px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
}

.showcase-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.showcase-content {
  padding: 1.5rem;
}

.showcase-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.8rem;
}

.showcase-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

.showcase-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.arrow-icon {
  font-size: 2.4rem;
  color: #FF631E;
  font-weight: bold;
  font-style: normal;
}


.showcase-cta {
  text-align: center;
  margin-bottom: 2rem;
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

/* 响应式设计 */
@media (max-width: 992px) {
  .showcase-row {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 400px;
  }

  .showcase-arrow {
    transform: rotate(90deg);
    height: 40px;
  }

  .arrow-icon {
    font-size: 1.5rem;
  }

  .showcase-section .section-title {
    font-size: 1.75rem;
  }
}

@media (max-width: 768px) {
  .showcase-section {
    padding: 3rem 0;
  }

  .showcase-image {
    height: 160px;
  }

  .showcase-card {
    flex: 0 0 auto;
    width: 100%;
    max-width: 320px;
  }

  .cta-button {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }

  .dialog-body {
    flex-direction: column;
    gap: 1.5rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: column;
    text-align: center;
    padding: 0.75rem;
  }

  .gallery-item img {
    width: 100%;
    max-width: 250px;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    margin-top: 0.75rem;
    margin-left: 0;
    font-size: 0.9rem;
  }
}

/* 专利校对服务部分 */
.patent-proofreading-section {
  padding: 1rem 0;
  background: #f8f9fa;
}

.patent-proofreading-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.patent-proofreading-section .main-title {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.patent-proofreading-section .main-desc {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.slogan-section {
  text-align: center;
  margin-bottom: 3rem;
}

.slogan {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.slogan-desc {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  max-width: 800px;
  margin: 0 auto;
}

.service-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 3rem;
}

.service-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.card-icon {
  width: 90px;
  height: 90px;
  background: #333;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  flex-shrink: 0;
}

.card-content p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.showcase-demo {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.showcase-demo img {
  flex: 1;
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
}

.demo-image {
  border-radius: 12px;
  overflow: hidden;
}

.image-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.5rem;
  height: 300px;
}

.image-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.demo-content {
  display: flex;
  align-items: center;
}

.patent-document {
  width: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.doc-header {
  background: #f5f5f5;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.doc-title {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

.doc-content {
  padding: 1rem;
}

.doc-line {
  font-size: 0.85rem;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  color: #333;
}

.doc-line.highlight {
  background: rgba(255, 99, 30, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  color: #FF631E;
  font-weight: 500;
}

.book-showcase {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.book-image {
  flex: 0 0 200px;
}

.book-image img {
  width: 100%;
  border-radius: 8px;
}

.book-description p {
  color: #666;
  font-size: 0.95rem;
  line-height: 1.8;
  margin: 0;
  text-align: justify;
}

/* 专利校对响应式 */
@media (max-width: 992px) {
  .service-cards {
    grid-template-columns: 1fr;
  }

  .showcase-demo {
    flex-direction: column;
  }

  .showcase-demo img {
    height: 200px;
  }

  .patent-proofreading-section .main-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .patent-proofreading-section {
    padding: 3rem 0;
  }

  .service-card {
    padding: 1.5rem;
  }

  .showcase-demo img {
    height: 150px;
  }

  .book-showcase {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 200px;
    width: auto;
  }

  .book-description {
    text-align: center;
  }
}

/* 无效诉讼案例部分 */
.invalid-cases-section {
  padding: 1rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.invalid-cases-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.invalid-cases-section .main-title {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 1rem;
  font-weight: 600;
}

.invalid-cases-section .main-desc {
  color: #666;
  font-size: 1rem;
  line-height: 1.8;
  max-width: 900px;
  margin: 0 auto;
}

.invalid-images {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.invalid-images img {
  flex: 1;
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
}

@media (max-width: 992px) {
  .invalid-images {
    flex-direction: column;
  }

  .invalid-images img {
    height: 200px;
  }

  .invalid-cases-section .main-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .invalid-cases-section {
    padding: 3rem 0;
  }

  .invalid-images img {
    height: 150px;
  }
}

/* 案例分区 */
.cases-section {
  padding: 3.5rem 0 4rem;
  background: #fff;
}

.cases-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.cases-grid.single-column {
  grid-template-columns: 1fr;
  max-width: 600px;
  margin: 0 auto;
}

.column-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .8rem;
}

.column-title {
  font-size: 1.2rem;
  color: #333;
  position: relative;
}

.column-title::after {
  content: '';
  display: block;
  width: 36px;
  height: 3px;
  background: #FF631E;
  margin-top: .4rem;
  border-radius: 3px;
}

.more-btn {
  background: #fff7f3;
  border: 1px solid #ffe3d6;
  color: #FF631E;
  border-radius: 20px;
  padding: .35rem .8rem;
  cursor: pointer;
  transition: all .2s ease;
}

.more-btn:hover {
  background: #FF631E;
  color: #fff;
  border-color: #FF631E;
}

.case-card {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 1rem;
  padding: .9rem;
  border-radius: 10px;
  border: 1px solid #f2f2f2;
  margin-bottom: .9rem;
  transition: box-shadow .2s ease;
}

.case-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.case-card .thumb {
  width: 120px;
  height: 80px;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
}

.case-card .case-title {
  font-size: 1rem;
  color: #333;
  margin-bottom: .35rem;
}

.case-card .case-brief {
  color: #666;
  font-size: .92rem;
  line-height: 1.5;
}

/* 联系部分样式 */
.contact-section {
  background-color: #007bff;
  color: white;
  padding: 4rem 0;
}

.contact-section .section-title {
  color: white;
}

.contact-section .section-text {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
}

.contact-content {
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .about-card {
    grid-template-columns: 1fr;
  }

  .creative-grid,
  .cases-grid {
    grid-template-columns: 1fr;
  }

  .creative-card .cover {
    height: 160px;
  }

  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-title {
    font-size: 4rem;
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }

  .banner-title {
    font-size: 3rem;
  }

  .banner-section {
    height: 400px;
  }
}

@media (max-width: 640px) {

  /* Dialog 平板端优化 */
  .contact-dialog .el-dialog {
    width: 90% !important;
  }

  .dialog-content {
    padding: 2rem 1.5rem;
  }

  .dialog-body {
    flex-direction: column;
    gap: 2rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: row;
    text-align: left;
    padding: 1rem;
  }

  .gallery-item img {
    width: 150px;
    max-width: 150px;
    flex-shrink: 0;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    margin-top: 0;
    margin-left: 1rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .showcase-card {
    max-width: 280px;
  }

  .showcase-image {
    height: 140px;
  }

  .showcase-content {
    padding: 1rem;
  }

  .showcase-title {
    font-size: 1rem;
  }

  .showcase-desc {
    font-size: 0.85rem;
  }

  /* Dialog 移动端优化 */
  .contact-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }

  .dialog-content {
    padding: 1.5rem 1rem;
  }

  .dialog-title {
    font-size: 1.5rem;
  }

  .dialog-body {
    gap: 1rem;
  }

  .dialog-body .text-content {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .gallery-item {
    padding: 0.5rem;
    margin-bottom: 0.75rem;
  }

  .gallery-item img {
    max-width: 200px;
  }

  .gallery-image {
    height: 80px;
  }

  .gallery-item .item-caption {
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }

  /* Book showcase 手机端优化 */
  .book-showcase {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    margin-bottom: 2rem;
  }

  .book-image {
    flex: none;
    align-self: center;
  }

  .book-image img {
    max-width: 150px;
    width: auto;
  }

  .book-description {
    text-align: left;
  }

  .book-description p {
    font-size: 0.9rem;
    line-height: 1.6;
  }
}

@media (max-width: 576px) {
  .banner-title {
    font-size: 2.5rem;
  }

  .section-title {
    font-size: 2rem;
  }
}

/* 图片说明文字样式 */
.patent-image-caption {
  padding: 1rem;
  background: white;
  text-align: center;
}

.caption-text {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  line-height: 1.4;
  position: relative;
}

.caption-text::before {
  content: '';
  position: absolute;
  top: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #FF631E;
  border-radius: 1px;
}

/* 无说明文字的图片项 */
.patent-image-item.no-caption {
  margin-bottom: 0;
}

/* 共享说明文字容器 */
.shared-caption-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  /* position: relative; */
}

.shared-caption {
  padding: 1rem 2rem;
  background: white;
  text-align: center;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 2px solid #FF631E;
  position: relative;
  overflow: hidden;
}

.shared-caption .caption-text {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  line-height: 1.4;
  position: relative;
}

.shared-caption .caption-text::before {
  content: '';
  position: absolute;
  top: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background: #FF631E;
  border-radius: 1px;
}

/* 添加悬停效果 */
.shared-caption::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 99, 30, 0.1), transparent);
  transition: left 0.5s ease;
}

.shared-caption:hover::before {
  left: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  /* 移动端图片网格改为单列 */
  .patent-images-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    max-width: 400px;
    margin: 0 auto 2rem;
  }
  
  /* 移动端说明文字容器改为垂直布局 */
  .high-value-patent-section div[style*="display: flex"] {
    flex-direction: column !important;
    align-items: center !important;
    gap: 1rem !important;
  }
  
  /* 重置移动端的margin */
  .high-value-patent-section .shared-caption-container {
    margin-left: 0 !important;
    margin-top: 0 !important;
  }

  .patent-image-caption,
  .shared-caption {
    padding: 0.8rem 1.5rem;
  }

  .caption-text {
    font-size: 0.9rem;
  }

  .patent-title {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  /* 进一步优化小屏幕 */
  .patent-images-grid {
    max-width: 320px;
    gap: 1rem;
  }
  
  .patent-image {
    height: 200px;
  }

  .patent-image-caption,
  .shared-caption {
    padding: 0.6rem 1.2rem;
  }

  .caption-text {
    font-size: 0.85rem;
  }
  
  .patent-title {
    font-size: 1.4rem;
  }
  
  .high-value-patent-section {
    padding: 3rem 0;
  }
}

@media (max-width: 360px) {
  /* 超小屏幕优化 */
  .patent-images-grid {
    max-width: 280px;
  }
  
  .patent-image {
    height: 180px;
  }
  
  .patent-title {
    font-size: 1.2rem;
  }
  
  .shared-caption {
    padding: 0.5rem 1rem;
  }
  
  .caption-text {
    font-size: 0.8rem;
  }

  .shared-caption-container {
    margin-top: 0.6rem;
  }
}

/* 高满意度客户区域样式 */
.high-satisfaction-clients-section {
  background:  linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  position: relative;
}

.high-satisfaction-clients-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dots2" width="25" height="25" patternUnits="userSpaceOnUse"><circle cx="12.5" cy="12.5" r="1.5" fill="%23e2e8f0" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23dots2)"/></svg>');
  pointer-events: none;
}

.high-satisfaction-clients-section .section-header {
  text-align: center;
  margin-bottom: 2.2rem;
  position: relative;
  z-index: 1;
}

.clients-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 2rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.clients-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  border-radius: 2px;
}

.clients-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  /* max-width: 900px; */
  margin: 0 auto;
  text-align: justify;
  padding: 0 1rem;
}

/* 客户展示网格 - 5列2行 */
.clients-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.client-item {
  background: white;
  border-radius: 16px;
  padding: 2rem 0.2rem;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
}

.client-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.client-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

.client-item:hover::before {
  opacity: 1;
}

.client-image {
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 2;
}

.client-logo {
  /* width: 80px; */
  height: 80px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.client-item:hover .client-logo {
  transform: scale(1.1);
}

.client-name {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.4;
  position: relative;
  z-index: 2;
}

/* 响应式设计 - 客户展示区域 */
@media (max-width: 1024px) {
  .clients-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }
  
  .clients-title {
    font-size: 2.2rem;
  }
}

@media (max-width: 768px) {
  .clients-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.2rem;
  }
  
  .client-item {
    padding: 1.5rem 1rem;
  }
  
  .client-logo {
    width: 60px;
    height: 60px;
  }
  
  .client-name {
    font-size: 0.9rem;
  }
  
  .clients-title {
    font-size: 1.8rem;
  }
  
  .clients-description {
    font-size: 1rem;
    padding: 0 1.5rem;
  }
  
  .high-satisfaction-clients-section {
    padding: 4rem 0;
  }
}

@media (max-width: 480px) {
  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  
  .client-item {
    padding: 1.2rem 0.8rem;
  }
  
  .client-logo {
    width: 50px;
    height: 50px;
  }
  
  .client-name {
    font-size: 0.85rem;
  }
  
  .clients-title {
    font-size: 1.5rem;
  }
  
  .clients-description {
    font-size: 0.95rem;
    padding: 0 1rem;
  }
  
  .high-satisfaction-clients-section {
    padding: 3rem 0;
  }
}

@media (max-width: 360px) {
  .clients-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
    max-width: 280px;
  }
  
  .client-item {
    padding: 1rem;
  }
  
  .clients-title {
    font-size: 1.3rem;
  }
  
  .clients-description {
    font-size: 0.9rem;
  }
}

/* 之于行团队概况样式 */
.team-overview-section {
  padding: 2rem 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.team-overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
  align-items: start;
}

/* 左侧背景信息样式 */
.team-background {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
}

.background-header,
.org-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 99, 30, 0.1);
}

.header-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: white;
  font-size: 1.2rem;
}

.background-title,
.org-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.background-content {
  margin-bottom: 2rem;
}

.background-text {
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 1rem 0;
  line-height: 1.6;
}

.highlight-text {
  color: #FF631E;
  font-weight: 700;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
}

.background-subtitle {
  margin: 0;
}

.national-badge {
  display: inline-block;
  background: linear-gradient(135deg, #FF631E 0%, #e55a1a 100%);
  color: white;
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 600;
}

.organization-info {
  border-top: 2px dashed rgba(255, 99, 30, 0.3);
  padding-top: 2rem;
}

.org-content {
  margin-top: 1rem;
}

.org-code {
  font-size: 1.1rem;
  color: #555;
  margin: 0;
  font-weight: 600;
}

/* 右侧数据统计样式 */
.team-statistics {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
}

.stats-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 99, 30, 0.1);
}

.stats-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  margin: 0;
}

/* 人员图标展示 */
.team-icons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 2rem 0;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid rgba(255, 99, 30, 0.1);
}

.team-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #333, #555);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.team-icon:hover {
  transform: scale(1.1);
  background: linear-gradient(135deg, #FF631E, #ff8c42);
}

/* 统计数据网格 */
.stats-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.stat-item {
  padding: 1.5rem;
  background: linear-gradient(135deg, #fff9f5 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.15);
}

.stat-label {
  font-size: 1rem;
  color: #666;
  margin-bottom: 0.8rem;
  font-weight: 500;
}

.stat-value {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.stat-text {
  font-size: 0.9rem;
  color: #888;
}

.stat-number,
.stat-percentage {
  font-size: 1.4rem;
  font-weight: 700;
}

.highlight-orange {
  color: #FF631E;
}

/* 特殊样式 */
.senior-engineers {
  border-left: 4px solid #FF631E;
}

.famous-talents {
  border-left: 4px solid #4a90e2;
}

.german-talents {
  border-left: 4px solid #28a745;
}

.overseas-background {
  border-left: 4px solid #dc3545;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .team-overview-content {
    gap: 3rem;
    margin: 0 1rem;
  }
}

@media (max-width: 992px) {
  .team-overview-section {
    padding: 3rem 0;
  }
  
  .team-overview-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .team-background,
  .team-statistics {
    padding: 2rem;
  }
}

@media (max-width: 768px) {
  .team-overview-section {
    padding: 2rem 0;
  }
  
  .team-background,
  .team-statistics {
    padding: 1.5rem;
    border-radius: 16px;
  }
  
  .background-title,
  .org-title,
  .stats-title {
    font-size: 1.2rem;
  }
  
  .background-text {
    font-size: 1.1rem;
  }
  
  .team-icons {
    gap: 0.3rem;
    padding: 1rem;
  }
  
  .team-icon {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .team-overview-content {
    margin: 0 0.5rem;
  }
  
  .team-background,
  .team-statistics {
    padding: 1.2rem;
  }
  
  .header-icon {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
  
  .background-title,
  .org-title,
  .stats-title {
    font-size: 1.1rem;
  }
  
  .background-text {
    font-size: 1rem;
  }
  
  .team-icons {
    gap: 0.2rem;
    padding: 0.8rem;
  }
  
  .team-icon {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  
  .stat-item {
    padding: 1.2rem;
  }
  
  .stat-number,
  .stat-percentage {
    font-size: 1.2rem;
  }
  
  .national-badge {
    font-size: 0.9rem;
    padding: 0.4rem 1rem;
  }
}
/* 行业荣誉与专业资质模块样式 */
.honors-credentials-section {
  padding: 0 0  1rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  position: relative;
}

.honors-credentials-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="dotsHonors" width="22" height="22" patternUnits="userSpaceOnUse"><circle cx="11" cy="11" r="1.2" fill="%23e2e8f0" opacity="0.35"/></pattern></defs><rect width="100" height="100" fill="url(%23dotsHonors)"/></svg>');
  pointer-events: none;
  opacity: 0.6;
}

.honors-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.4;
  position: relative;
  display: inline-block;
}

.honors-title::after {
  content: '';
  position: absolute;
  bottom: -0.6rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  border-radius: 2px;
}

.honors-description {
  font-size: 1.05rem;
  line-height: 1.9;
  color: #4a5568;
  max-width: 980px;
  margin: 0 auto;
  text-align: justify;
  padding: 0 1rem;
}

/* 两行各三列的图片网格 */
.honors-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.honor-item {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  position: relative;
  transition: all 0.3s ease;
}

.honor-item::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.12) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.honor-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.honor-item:hover::before {
  opacity: 1;
}

.honor-image {
  width: 100%;
  height: 240px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
  background: #fff;
}

.honor-item:hover .honor-image {
  transform: scale(1.03);
}

/* 响应式 */
@media (max-width: 1024px) {
  .honors-title {
    font-size: 1.9rem;
  }
  .honors-description {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .honors-credentials-section {
    padding: 3rem 0;
  }
  .honors-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
    max-width: 420px;
    margin: 0 auto 1.8rem;
  }
  .honor-image {
    height: 200px;
  }
  .honors-title {
    font-size: 1.6rem;
  }
}

@media (max-width: 480px) {
  .honors-grid {
    max-width: 320px;
    gap: 1rem;
  }
  .honor-image {
    height: 180px;
  }
  .honors-title {
    font-size: 1.4rem;
  }
}

/* 居中修复：行业荣誉与专业资质标题 */
.honors-credentials-section .section-header {
  text-align: center;
}
/* 第一排三图独立样式，避免与其他模块冲突 */
.honors-grid-top {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.honor-card-top {
  height: 22rem; /* 外层高度 22rem */
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  position: relative;
  transition: all 0.3s ease;
  margin: 0 3.5rem;
  padding: 0 0.25rem; /* 左右各 0.25rem，使外层总比图片宽 0.5rem */
  box-sizing: border-box;
}

.honor-card-top::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.12) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.honor-card-top:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.honor-card-top:hover::before {
  opacity: 1;
}

.honor-image-top {
  display: block;
  width: 100%;       /* 图片宽度 100% */
  max-height: 22rem; /* 图片最大高度 29rem */
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  background: #fff;
}

.honor-card-top:hover .honor-image-top {
  transform: scale(1.02);
}

/* 响应式 */
@media (max-width: 768px) {
  .honors-grid-top {
    grid-template-columns: 1fr;
    gap: 1.2rem;
    max-width: 420px;
    margin: 0 auto 1.8rem;
  }
  .honor-card-top {
    height: 22rem;
    padding: 0 0.25rem;
  }
  .honor-image-top {
    max-height: 22rem;
  }
}
</style>